import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const bffPharmacyCounselingKeys = createQueryKeyStore({
  counselingSlot: {
    list: (pharmacyId) => [pharmacyId],
  },
});
